import $ from 'jquery';
import scrollIntoView from 'scroll-into-view-if-needed';
import sleep from './sleep';
import { clearStoredAllMarks } from 'library-@/components/image-panel-v3/src/smart-image-adjust-layer/ChangeService.ts';
import smartImageService from '@/services/smartImageService';

let cacheMap = new Map();

function getKey(patentId, imageUrl, box, imageType) {
    return `getFigures_${patentId}_${imageUrl}_${JSON.stringify(box)}_${imageType}`;
}
let lastPatentId;

export async function fetchFigures(model, overwriteBox) {
    let imageUrl = model.image4Figures || model.path || model.src;
    let imageType = model.image_type;
    // let imageId = model.imageId;
    let box = overwriteBox || model.box;
    // let resolution = model.oriWidth ? `${model.oriWidth}*${model.oriHeight}` : undefined;

    let key = getKey(this.patentId, imageUrl, box, imageType);

    if (lastPatentId !== this.patentId) {
        cacheMap.clear();
        clearStoredAllMarks();
    }
    lastPatentId = this.patentId;
    let figuresString = cacheMap.get(key) || model.figure;
    /* if (!figuresString) {
        let lang = window.CURRENT_FIGURE_LANG_DEFAULT || window.CURRENT_LANG_DEFAULT;
        let category = model.category;
        const pn = get(this.patent, 'PN');
        figuresString = await getFigures(this.patentId, imageUrl, box, lang, category, resolution, imageType, imageId, pn);
        // figuresString = await import('./mockFigureXHR.json');
        cacheMap.set(key, figuresString);
    } */

    let figuresResp = typeof figuresString === 'string' ? JSON.parse(figuresString) : figuresString;

    let figures = { captions: figuresResp.fig || [], parts: figuresResp.parts || [] };
    const applyOriginals = item => {
        return { ...item, original_text: item.original_text || item.text, original_code: item.original_code || item.code };
    };
    figures.captions = figures.captions.map(applyOriginals);
    figures.parts = figures.parts.map(applyOriginals);

    return figures;
}

export async function jumpBySelector(jump2selector, index = 0) {
    await sleep(200);
    let $allTarget = $(jump2selector);
    // 尽量不去选取内空的标签
    let target = $allTarget.get(index);

    if (target) {
        if (target.scrollIntoViewIfNeeded) {
            target.scrollIntoViewIfNeeded();
        } else {
            scrollIntoView(target, {
                scrollMode: 'if-needed',
                inline: 'end',
                block: 'nearest',
                behavior: 'smooth',
            });
        }
    }
    return { ele: target, $allTarget };
}


export function getTargetContentList(figure) {
    let { id } = figure;
    let attr = 'class';
    let selector = `[${attr}~="${id}"]`;
    return $(selector)
        .filter(function() {
            return this.innerHTML !== '';
        });
}

export function addAnimation(ele, className, duration = 0.8 * 4) {
    $(ele).on('animationend', function(event) {
        $(this).off(event);
        $(ele).removeClass(className);
    });
    $(ele).addClass(className);
    setTimeout(() => {
        $(ele).removeClass(className);
    }, duration * 1000 + 300);
}

/**
 * 跳转到文本位置
 * @param {Object} figure
 * @param {Number} index
 * @param {String|Array<HTMLElement>} allTargets
 */
export async function jumpToContent(figure, index, allTargets = getTargetContentList(figure)) {
    let { ele } = await jumpBySelector(allTargets, index);

    addAnimation(ele, 'figure_shine');

    window.rvTrack('Click Image part', {
        target: 'Description',
    });
}

export async function jumpToFigure(figureOrId, wrapper) {
    let id = typeof figureOrId === 'string' ? figureOrId : figureOrId ? figureOrId.id : '';

    let attr = 'data--tfpart-id';

    let selector = `[${attr}="${id}"]`;
    await sleep(200);
    let target =
        $(selector)
            .closest('.img-flip-container')
            .get(0) || selector;

    window.rvTrack('Click Image part', {
        target: 'Image',
    });
    return jumpBySelector(target);
}

export async function jumpToLabel(id, wrapper = document.body) {
    const imageId = smartImageService.getImageIdFromLabelId(id);
    const selector = `#thum-image-image-id-${(imageId|| '').replace(/\./g, '_')}`;
    await sleep(200);
    let target =
        $(wrapper)
            .find(selector)
            .closest('.img-flip-container')
            .get(0) || selector;
    return jumpBySelector(target);
}

export async function jumpToLabelByText(text, wrapper = document.body) {
    const imageId = smartImageService.getImageIdFromLabelText(text);
    const selector = `#thum-image-image-id-${(imageId|| '').replace(/\./g, '_')}`;
    await sleep(200);
    let target =
        $(wrapper)
            .find(selector)
            .closest('.img-flip-container')
            .get(0) || selector;
    return jumpBySelector(target);
}
